/**
 * internal dependencies
 */
import { awsApiInstance } from '../api/aws-api';
import { setCognitoStore, getCognitoStore } from '../auth/cognito-store';

/**
 * Handles sending the refresh token to the api gateway to get a new access token.
 * 
 * @returns Promise<any>
 */
const CognitoRefreshUser = async () => {
  const { RefreshToken } = getCognitoStore();

  const modalData = {
    refreshToken: RefreshToken
  };

  const { data } = await awsApiInstance.post('/auth/refresh', modalData);

  setCognitoStore(data);

  return data;
};

export default CognitoRefreshUser;